module.exports = __webpack_public_path__ + "img/产品.9da326a4.svg";